import { useTranslation, Trans } from "react-i18next";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="landing-hero">
      <div className="landing-hero-image">
        <img src="/Landing page assets/sulhafa group banner.png" alt="Sulhafa banner" />
      </div>
      <div className="landing-hero-text">
        <h1>
          <Trans i18nKey="hero.title">
            Where Every <span>Pet's Story</span> Begins
          </Trans>
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
